import router from '@/router';
import store from '@/store';

/**
 * Redirect to url
 *
 * @param  {string} url URL to redirect to.
 * @returns {void}
 */
export const redirect = (url = '/') => {
    router.push(url).catch(() => {});
};

/**
 * Redirect after login.
 *
 * Performs a full page load instead of a client-side push so the dashboard
 * boots from a clean, authenticated state. A client-side redirect keeps store
 * data fetched while logged out — including lazy-loaded keys such as `shows`,
 * which a 401 commits as `false`. The lazy-load plugin never retries those,
 * which left the dashboard spinning until a manual refresh.
 *
 * @returns {void}
 */
export const loginRedirect = () => {
    window.location.assign(store.state.loginRedirectUrl || '/');
};

export default redirect;
